const questions = [
  {
    type: "music",
    image1: "/questions/music1.jpg",
    image2: "/questions/music2.jpg",
    music1: "/questions/music1.mp3",
    music2: "/questions/music2.mp3",
    property1: "symmetry",
    property2: "asymmetry",
  },
  {
    type: "image",
    image1: "/questions/a1.jpg",
    image2: "questions/a2.jpg",
    property1: "minimalism",
    property2: "maximalism",
  },
  {
    type: "image",
    image1: "/questions/a4.jpg",
    image2: "questions/a5.jpg",
    property1: "minimalism",
    property2: "maximalism",
  },
  {
    type: "image",
    image1: "/questions/a6.jpg",
    image2: "questions/a7.jpg",
    property1: "minimalism",
    property2: "maximalism",
  },
  {
    type: "image",
    image1: "/questions/b1.jpg",
    image2: "questions/b2.jpg",
    property1: "symmetry",
    property2: "asymmetry",
  },
  {
    type: "image",
    image1: "/questions/b4.jpg",
    image2: "questions/b5.jpg",
    property1: "symmetry",
    property2: "asymmetry",
  },

  {
    type: "image",
    image1: "/questions/c1.jpg",
    image2: "questions/c2.jpg",
    property1: "light",
    property2: "dark",
  },
  {
    type: "image",
    image1: "/questions/c4.jpg",
    image2: "questions/c5.jpg",
    property1: "light",
    property2: "dark",
  },
  {
    type: "image",
    image1: "/questions/c7.jpg",
    image2: "questions/c6.jpg",
    property1: "light",
    property2: "dark",
  },
];

export default questions;
